import { Channel } from 'api/ChannelsAPI';
import { EspAccount } from 'modules/graphql/types';
import { Spinner } from 'ui/spinner';
import { getMediumByKey } from 'utils/messageMediums';
import { useChannelModalsContext, useSearchContext } from '../contexts';
import { MessageTypesByChannelId } from '../types';
import { sortMessageTypes } from '../utils';
import { ChannelCard } from './ChannelCard';
import { NewMessageTypeButton } from './ChannelCard/NewMessageTypeButton';
import { EmptyChannelCard } from './EmptyChannelCard';
import { ErrorPage } from './ErrorPage';
import { NoResultsCard } from './NoResultsCard';

export const TEXT = {
  CONTENT_HEADING: 'Message types',
};

type TempProps = {
  channels: Channel[]; // allChannels before filtering/pagination
  espAccounts: EspAccount[];
  isLoading: boolean;
  messageTypesByChannelId: MessageTypesByChannelId;
  messageMedium: string;
  paginatedChannels: Channel[]; // currentChannels: filtered and paginated
};

export const ChannelsList = ({
  channels,
  espAccounts,
  isLoading,
  messageTypesByChannelId,
  messageMedium,
  paginatedChannels,
}: TempProps) => {
  const { showCreateMessageTypeModal } = useChannelModalsContext();
  const { inputValue } = useSearchContext();
  const medium = getMediumByKey(messageMedium);

  if (isLoading) {
    return <Spinner />;
  }

  // message medium not found from known mediums, maybe a typo in URL bar or something?
  if (!medium) {
    return <ErrorPage />;
  }

  // channels before paginating or filtering with search input
  if (channels?.length < 1) {
    return (
      <EmptyChannelCard
        messageMedium={medium?.messageType}
        hasEspAccounts={espAccounts?.length > 0}
      />
    );
  }

  // channels after filtering, to disply a no results screen
  if (paginatedChannels?.length < 1) {
    return <NoResultsCard />;
  }

  return (
    <>
      {paginatedChannels.map((channel) => {
        const messageTypes = sortMessageTypes(messageTypesByChannelId[channel.id]);

        return (
          <ChannelCard
            channel={channel}
            customCardAction={
              <NewMessageTypeButton onClick={() => showCreateMessageTypeModal(channel)} />
            }
            espAccounts={espAccounts}
            inputValue={inputValue}
            key={channel.id}
            messageTypes={messageTypes}
          />
        );
      })}
    </>
  );
};
